export const promiseHandler = (promise) => {
  return promise.then((data) => ({error: null, data})).catch((error) => ({error, data: null}));
}